module.exports = __webpack_public_path__ + "img/Ellipse8.5aee55e6.png";